import { render, staticRenderFns } from "./MessagesAnnoucement.vue?vue&type=template&id=da104404&"
import script from "./MessagesAnnoucement.vue?vue&type=script&lang=js&"
export * from "./MessagesAnnoucement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports